import { render, staticRenderFns } from "./BlurHashResponsivePicture.vue?vue&type=template&id=5ca8f918&"
import script from "./BlurHashResponsivePicture.vue?vue&type=script&lang=js&"
export * from "./BlurHashResponsivePicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlurHashPicture: require('/codebuild/output/src3208117147/src/studio-frank/components/global/BlurHashPicture.vue').default,ResponsivePicture: require('/codebuild/output/src3208117147/src/studio-frank/components/global/ResponsivePicture.vue').default})
